import DataUtils from '../DataUtils'
import EventBase from "./EventBase"
import EventID from "./EventID"

class EventCallScene extends EventBase {

    constructor(Parameter?: string[]) {
        super()
        this.Parameter = Parameter || []
    }

    Code = EventID.CallScene

    setLocalesParam(indexes: number[]): void {
        indexes = []
    }

    /**
     * SceneId
     */
    get sceneId() {
        return this.Parameter[0]
    }

    set sceneId(val: string) {
        this.Parameter[0] = val
    }

    /**
     * 传入参数  注：传入传出参数规则：每项使用分隔符“|”相隔，每项中格式为类型+“@”+取值。
							 类型：0-5，分别对应：数值，字符串，数组，实例，二周目数值，常量；
							 取值：0-4：所取类型的索引值，5：为n&m结构，n为常量表索引，m为表中元素索引
							 例：0@3|1@3|3@82，意义为共3个输入参数，分别是数值3，字符串3和实例82
     */
    get inputParams():{ type: string; value: string }[]{
        const inputParams = this.Parameter[1].split('|')
        const params = inputParams.map(val =>
                (
                    { 
                        type: val.split('@')[0],
                        value: val.split('@')[1] 
                    }
                )
            )
        return params
    }

    set inputParams(val: { type: string; value: any }[]) {
        const str = val.reduce((acc, cur) => acc + `${cur.type}@${cur.value}|`, '')
        this.Parameter[1] = str.slice(0, -1)
    }

    /**
     * 获取输入参数的第n个参数的value(多语言 key )
     * @param index 
     */
    getInputParamsValue(index:number):string{
        const params = this.inputParams
        if (index >= 0 && index < params.length){
            return params[index].value
        } else {
            return ""
        }
    }

    /**
     * 传出参数
     *  注：传入传出参数规则：每项使用分隔符“|”相隔，每项中格式为类型+“@”+取值。
							 类型：0-5，分别对应：数值，字符串，数组，实例，二周目数值，常量；
							 取值：0-4：所取类型的索引值，5：为n&m结构，n为常量表索引，m为表中元素索引
							 例：0@3|1@3|3@82，意义为共3个输入参数，分别是数值3，字符串3和实例82
     */
    get outputParams() {
        const outputParams = this.Parameter[2].split('|')
        return outputParams.map(val => ({ type: val.split('@')[0], value: val.split('@')[1] }))
    }

    set outputParams(val: { type: string; value: any }[]) {
        const str = val.reduce((acc, cur) => acc + `${cur.type}@${cur.value}|`, '')
        this.Parameter[2] = str.slice(0, -1)
    }

    /**
     * scene 名称
     */
    get sceneName() {
        return this.Parameter[3]
    }

    set sceneName(val: string) {
        this.Parameter[3] = val
    }

    /**
     * 描述信息
     */
    get Description() {
        return `呼叫Scene：${this.Parameter[3]}`
    }
}

export default EventCallScene